// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2EKAr","col":"styles_col__FoQ-T"};